import { getBalloonLayout } from '../../components/map/infrastructure_balloon';
import { InfrastructureCategory, InfrastructureType } from '../../types/mvk_state';

// tslint:disable:max-line-length
var createIcon = function createIcon(content) {
  return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 54 61\" width=\"54\" height=\"61\">\n    <filter id=\"infrastructure-icon-layout\" width=\"134.8%\" height=\"129.6%\" x=\"-17.4%\" y=\"-7.4%\" filterUnits=\"objectBoundingBox\">\n      <feOffset dy=\"4\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\n      <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"2\"/>\n      <feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0\"/>\n    </filter>\n    <ellipse cx=\"27\" cy=\"53.5\" fill-opacity=\".15\" rx=\"5\" ry=\"1.5\"/>\n    <path d=\"M24.28 45.84C12.86 44.496 4 34.783 4 23 4 10.297 14.297 0 27 0s23 10.297 23 23c0 11.782-8.86 21.495-20.28 22.84L27 54l-2.72-8.16z\" filter=\"url(#infrastructure-icon-layout)\"/>\n    <path fill=\"#FFF\" d=\"M27 0C14.297 0 4 10.297 4 23c0 11.783 8.86 21.496 20.28 22.84L27 54l2.72-8.16C41.14 44.495 50 34.782 50 23 50 10.297 39.703 0 27 0z\"/>\n    <circle cx=\"27\" cy=\"23\" r=\"18\" fill=\"none\" stroke=\"#999\" stroke-width=\"4\"/>\n    <g fill=\"#7A7A7A\" transform=\"translate(4, 0)\">\n      ".concat(content, "\n    </g>\n  </svg>");
};
var IconSchools = createIcon("<path d=\"M31.9 17.9h-.2l-1.7 1V28s-.2.2-.3.2h-.3c-1.5 0-4.2.2-6 1.2l-.4.2-.3-.1c-1.8-1-4.5-1.2-6-1.2h-.4l-.2-.2V19l-1.8-1H14v11.5c0 .1 0 .1.1.1 0 0 .1.1.1 0 .5-.1 1.4-.1 2.4-.1 2.1 0 3.8.3 4.9.9.2.1 1.1.6 1.5.6.4 0 1.4-.5 1.5-.6 1.1-.6 2.8-.9 4.9-.9 1 0 1.8.1 2.4.1h.1l.1-.1V18.1c0-.1 0-.2-.1-.2zm-7.7 10.2h.2c1.2-.5 2.8-.8 4.6-.9.1 0 .2-.1.2-.2V16.1c0-.1 0-.1-.1-.1h-.2l-4.7 2c-.1 0-.1.1-.1.2v9.7c0 .1 0 .1.1.2zm-7-1c1.8 0 3.4.3 4.6.9h.2l.1-.1v-9.7c0-.1 0-.1-.1-.2l-4.7-2h-.2l-.1.1V27c.1 0 .2.1.2.1z\"/>");
var IconKindergarden = createIcon("<path d=\"M18.6 20.9c1.4 0 2.5-1 2.5-2.3 0-.8.3-1.5-.4-1.9-.4-.2-2.1-.4-2.6-.4-.6 0-1.4.5-1.8.8-.5.4-.1.8-.1 1.5-.1 1.3 1 2.3 2.4 2.3zm-1.8-2.5c.5-.1.8.1.8.1l.8-.3s-.4.5 0 .3c.8-.2 1.6-.1 2.1-.1v.3c0 .9-.8 1.7-1.8 1.7s-1.8-.8-1.8-1.7c-.1-.1-.1-.2-.1-.3zm7.5 2.7c-.1-1.2.5-2 .7-2.2.2 1.3 1.4 2.2 2.8 2.2 1.3 0 2.5-.9 2.8-2.1.2.4.6 1.2.5 2 2.4 0 1.2-2.6-.5-2.9 0-.1 0-.3-.1-.4 0-.6-.7-2.2-2.9-2.2-1.9 0-2.3 1.4-2.4 2.2-.1.2-.1.4-.1.6-2.7.4-2.4 2.8-.8 2.8zm2.2-3.4s.2.1.2.8c.4.1 1.2-1.2 1.2-1.2v1c.5.1 1.9 0 1.9 0h.1v.1c0 1.1-.9 1.9-2.1 1.9-1.1 0-2-.8-2.1-1.9.5 0 .8-.7.8-.7zm1.9 3.6h-2.2l-3 3.3-2.9-3.3H17l-3.4 3.5.7.7 2.4-1.9v3.8h.5v2.9h-.3v.2h1.6v-3.2h.5v3.2h1.4v-.3H20v-2.9h.6v-3.7l2 1.9.8-.2.4.1L26 23l.1.9-2.1 3.3h2.4v2.9h-.3v.4h1.4v-3.2h.5v3.2h1.4v-.3h-.3v-2.9H31L29.2 24l.1-1.2 2.2 2.7 1-1-2.9-3.2h-1.2z\"/>");
var IconPolyclinics = createIcon("<path d=\"M32 20h-6v-6h-6v6h-6v6h6v6h6v-6h6z\"/>");
var IconGroceryStores = createIcon("<path d=\"M32.2 16.3c-.1-.2-.4-.3-.7-.3H17.9l-.2-1.2c-.1-.5-.5-.8-1-.8h-2.2c-.5 0-1 .4-1 1s.4 1 1 1h1.4l1.8 11.2v.1c0 .1 0 .1.1.2 0 .1.1.1.1.2l.1.1c.1.1.1.1.2.1 0 0 .1 0 .1.1.1 0 .2.1.4.1h10.9c.5 0 1-.4 1-1s-.4-1-1-1H19.5l-.2-1h11.2c.5 0 .9-.4 1-.9l1-7c0-.3-.1-.6-.3-.9zM21.6 23H19l-.3-2h2.9v2zm0-3h-3.1l-.3-2h3.4v2zm4 3h-3v-2h3v2zm0-3h-3v-2h3v2zm4.1 3h-3.1v-2H30l-.3 2zm.4-3h-3.5v-2h3.8l-.3 2zM20 29c-.8 0-1.5.7-1.5 1.5S19.2 32 20 32s1.5-.7 1.5-1.5S20.8 29 20 29zm8 0c-.8 0-1.5.7-1.5 1.5S27.2 32 28 32s1.5-.7 1.5-1.5S28.8 29 28 29z\"/>");
var IconCafes = createIcon("<path d=\"M21.49 20c-1.198-2.3 6.29-7.9-1.498-8 4.493 1.9-2.396 7 1.498 8zm3.394 0c-.699-1.5 2.596-4.2.2-5 .599 1.4-2.596 4.2-.2 5zm7.688 3c-.5-.8-1.498-1.2-2.596-1.2v-.4c0-.2-.2-.3-.3-.3H15.3c-.2 0-.3.2-.3.3 0 2.1.4 4 1.198 5.7.799 1.8 1.997 3.1 3.395 3.9h5.69c.9-.5 1.698-1.2 2.397-2.2 2.596 0 4.493-1.6 4.992-3.1.499-.9.4-1.9-.1-2.7zm-1.398 2.2c-.3.8-1.198 1.6-2.496 1.9.5-1.1.899-2.4 1.098-3.7h.1c.6 0 .999.2 1.198.5.3.4.3.8.1 1.3z\"/>");
// tslint:enable:max-line-length

var schools;
var kindergarden;
var polyclinics;
var groceryStores;
var cafe;
function initIcons(ymaps) {
  if (!schools) {
    schools = ymaps.templateLayoutFactory.createClass(IconSchools);
  }
  if (!kindergarden) {
    kindergarden = ymaps.templateLayoutFactory.createClass(IconKindergarden);
  }
  if (!polyclinics) {
    polyclinics = ymaps.templateLayoutFactory.createClass(IconPolyclinics);
  }
  if (!groceryStores) {
    groceryStores = ymaps.templateLayoutFactory.createClass(IconGroceryStores);
  }
  if (!cafe) {
    cafe = ymaps.templateLayoutFactory.createClass(IconCafes);
  }
}
export function getInfrastructureIconLayout(ymaps, type) {
  initIcons(ymaps);
  switch (type) {
    case InfrastructureType.Schools:
      return schools;
    case InfrastructureType.Kindergarden:
      return kindergarden;
    case InfrastructureType.Polyclinics:
      return polyclinics;
    case InfrastructureType.GroceryStores:
      return groceryStores;
    case InfrastructureType.Cafes:
      return cafe;
    default:
      return null;
  }
}
export function convertInfrastructureListToFeatureList(ymaps, list) {
  return list.reduce(function (acc, item) {
    var featureType = getInfrastructureType(item.category);
    if (featureType !== undefined) {
      var features = item.companies.map(function (company) {
        return convertInfrastructureToFeature(ymaps, company, featureType);
      });
      return acc.concat(features);
    }
    return acc;
  }, []);
}
function convertInfrastructureToFeature(ymaps, item, type) {
  return {
    geometry: {
      coordinates: [item.coordinates.lon, item.coordinates.lat],
      type: 'Point'
    },
    id: String(item.id),
    infrastructureType: type,
    options: {
      balloonLayout: getBalloonLayout(ymaps),
      iconLayout: getInfrastructureIconLayout(ymaps, type),
      iconOffset: [-27, -61],
      iconShape: {
        coordinates: [27, 27],
        radius: 26.5,
        type: 'Circle'
      },
      iconSize: [54, 61],
      zIndex: 1
    },
    properties: {
      objects: [{
        name: item.name,
        type: type
      }]
    },
    type: 'Feature'
  };
}
export function getInfrastructureType(item) {
  var keys = Object.keys(InfrastructureCategory).map(Number);
  return keys.find(function (key) {
    return InfrastructureCategory[key] === item;
  });
}